import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalProposedWorksService } from "services/ClientPortalProposedWorksService";
import { ClientPortalProposedWorkFiltersModel, ClientPortalProposedWorkModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  ProposedWorks: new Array<ClientPortalProposedWorkModel>(),
  Loading: false,
};

export const ProposedWorksTableSlice = createSlice({
  name: "ProposedWorksTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProposedWorks.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getProposedWorks.fulfilled, (state, action) => {
        state.ProposedWorks = action.payload;
        state.Loading = false;
      })
      .addCase(getProposedWorks.rejected, (state) => {
        state.ProposedWorks = new Array<ClientPortalProposedWorkModel>();
        state.Loading = false;
      });
  },
});

export const getProposedWorks = createAsyncThunk<
  ClientPortalProposedWorkModel[],
  { proposedWorkFilters: ClientPortalProposedWorkFiltersModel }
>("ProposedWorksTable/GetProposedWorks", async ({ proposedWorkFilters }) => {
  const proposedWorksService = container.get<IClientPortalProposedWorksService>(
    SERVICE_TYPES.ClientPortalProposedWorksService
  );
  return await proposedWorksService.getProposedWorks(proposedWorkFilters);
});

export const selectProposedWorks = (state: RootState) => state.proposedWorksTable.ProposedWorks;
export const selectLoadingProposedWorks = (state: RootState) => state.proposedWorksTable.Loading;

export default ProposedWorksTableSlice.reducer;
